
<script lang="ts">
    import { navigate } from "svelte-navigator";
    import { Button, TabContent, TabPane } from "sveltestrap";
    import AppWrapper from "../components/AppWrapper.svelte";
    import FormsTable from "../components/FormsTable.svelte";
    import type { Form } from "../Model/Form";
    import { formsFactory, formsService, uiService } from "../services";

    let offset = 0;
    let limit = 100;
    let forms: Form[];
    let formsProduction: Form[] = [];
    let formsDeveloped: Form[] = [];
    let formsDeprecated: Form[] = [];
    let formsBasket: Form[] = [];

    load();

    async function load(){
        forms = await formsService.findForms(offset, limit);
        spreadForms(forms);
    }

    function spreadForms(forms: Form[]): void {
        const production: Form[] = [];
        const developed: Form[] = [];
        const deprecated: Form[] = [];
        const basket: Form[] = [];
        for (const form of forms) {
            if (form.disabled) {
                basket.push(form);
            } else if (!form.status) {
                deprecated.push(form);
            } else if (form.production) {
                production.push(form);
            } else {
                developed.push(form);
            }
        }
        formsProduction = production;
        formsDeveloped = developed;
        formsDeprecated = deprecated;
        formsBasket = basket;
    }

    async function newForm(){
        try {
            const form = formsFactory.createNewForm();
            await formsService.saveForm(form);
            navigate(`/formulario/${form.id}`);
        } catch (error) {
            console.error(error);
            uiService.notifyError('Ha ocurrido un error al crear el formulario.');
        }
    }

    function onDisabled(): void {
        spreadForms(forms);
    }

    function onEnabled(): void {
        spreadForms(forms);
    }

    function onRemoved(): void {
        spreadForms(forms);
    }

    function onDuplicated({ detail: form }: CustomEvent): void {
        forms = [...forms, form];
        spreadForms(forms);
    }

</script>

<AppWrapper>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-sm-9 mb-3">
                <div class="text-start">
                    <h3>Listado de Formularios</h3>
                </div>
              </div>
          <div class="col-12 col-sm-3 mb-3">
            <div class="text-end">
                <Button color="primary" on:click={() => newForm()}>
                    Nuevo formulario
                </Button>
            </div>
          </div>
          <div class="col">
            {#if forms?.length}

            <TabContent>
                <TabPane tabId="developedId" active>
                    <span slot="tab">
                        Desarrollo ({formsDeveloped.length})
                    </span>
                    <FormsTable
                        forms={formsDeveloped}
                        on:disabled={onDisabled}
                        on:enabled={onEnabled}
                        on:removed={onRemoved}
                        on:duplicated={onDuplicated} />
                </TabPane>

                <TabPane tabId="productionId">
                    <span slot="tab">
                        Producción ({formsProduction.length})
                    </span>
                    <FormsTable
                        forms={formsProduction}
                        on:disabled={onDisabled}
                        on:enabled={onEnabled}
                        on:removed={onRemoved}
                        on:duplicated={onDuplicated} />
                </TabPane>

                <TabPane tabId="deprecatedId">
                    <span slot="tab">
                        Archivados ({formsDeprecated.length})
                    </span>
                    <FormsTable
                        forms={formsDeprecated}
                        on:disabled={onDisabled}
                        on:enabled={onEnabled}
                        on:removed={onRemoved}
                        on:duplicated={onDuplicated} />
                </TabPane>

                <TabPane tabId="basketId">
                    <span slot="tab">
                        Papelera ({formsBasket.length})
                    </span>
                    <FormsTable
                        forms={formsBasket}
                        on:disabled={onDisabled}
                        on:enabled={onEnabled}
                        on:removed={onRemoved}
                        on:duplicated={onDuplicated} />
                </TabPane>
              </TabContent>

        {:else}
            <div class="text-center pt-5">
                <hr>
                <h3>No hay formularios para mostrar</h3>
            </div>
        {/if}
          </div>
        </div>
    </div>
</AppWrapper>


